<template>
  <div class="paginPage">
    <el-pagination
      @current-change="currentChange"
      @size-change="sizeChange"
      :current-page="pagination.currentPage"
      :page-size="pagination.pageSize"
      :page-sizes="pageSizes"
      layout="sizes, prev, pager, next, jumper, slot"
      :total="pagination.total"
    >
      <el-link type="primary" :underline="false" @click="refreshBtn">刷新</el-link>
      <span class="text">显示 {{pagination.beginIndex}} 到 {{pagination.endIndex}}，共 {{pagination.total}}{{sumTotal}} 条</span>
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    pagination: {
      type: Object,
      default: function() {
        return {};
      }
    },
    sumTotal: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pageSizes: [10, 20, 30, 40, 50, 100]
    };
  },
  methods: {
    // 分页当前页改变触发
    currentChange(val) {
      this.$emit("currentChange", val);
    },
    // 分页每页显示数量改变时触发
    sizeChange(val) {
      this.$emit("sizeChange", val);
    },
    // 刷新
    refreshBtn() {
      this.$emit("refreshBtn");
    }
  }
};
</script>

<style lang="less" scoped>
.paginPage {
  overflow: auto;
  background-color: var(--bgPanel);
  border-left: 1px solid var(--borderLight);
  border-right: 1px solid var(--borderLight);
}
// 全局分页样式
.el-pagination {
  margin: 0 1px;
  text-align: center;
  min-width: 800px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;

  /deep/input,
  /deep/li,
  /deep/span {
    font-size: 14px !important;
  }

  // 刷新
  .el-link {
    margin: 0 20px;
  }

  .text {
    color: var(--textRegular);
    font-weight: 400;
  }
}
</style>